import { useState } from "react"
import {
	IconChevronDownOutline18 as ChevronDown,
	IconChevronRightOutline18 as ChevronRight,
} from "nucleo-ui-outline-18"

import { Button } from "@productlane/ui"
import { BoltIcon } from "@productlane/ui/src/icons/project/bolt-icon"

import type { TimelineEventProps } from "./types"
import { ActivityEvent } from "./activity-event"
import {
	buildAgentBurstExpandLabel,
	buildAgentBurstLabel,
} from "./agent-burst-summary"
import { SystemEvent } from "./base/system-event"

export function AgentActivityBurstEvent({
	event,
	hasEventAbove = false,
	hasEventBelow = false,
}: TimelineEventProps) {
	const [expanded, setExpanded] = useState(false)

	if (event.type !== "agentActivityBurst") return null

	const { burst } = event
	const members = burst.events
	const label = buildAgentBurstLabel(members)
	const expandLabel = buildAgentBurstExpandLabel(members)
	const Chevron = expanded ? ChevronDown : ChevronRight

	return (
		<div className={expanded && !hasEventBelow ? "pb-2" : undefined}>
			<SystemEvent
				icon={<BoltIcon className="h-3.5 w-3.5 text-secondary" />}
				timestamp={new Date(burst.createdAt)}
				hasEventAbove={hasEventAbove}
				hasEventBelow={hasEventBelow || expanded}
			>
				<Button
					variant="link-no-hover"
					size="sm"
					onClick={() => setExpanded((value) => !value)}
					iconRight={Chevron}
					aria-expanded={expanded}
					className="h-auto min-w-0 max-w-full justify-start gap-1.5 py-0 text-xs font-normal"
					// The button's own gap sits between its icon and the label block, so
					// the two spans below need their own.
					wrapperClassName="gap-1.5"
				>
					<span className="flex-none text-secondary">{label}</span>
					{!expanded ? (
						<span className="truncate text-tertiary">{expandLabel}</span>
					) : null}
				</Button>
			</SystemEvent>

			{expanded
				? members.map((member, index) => (
						<ActivityEvent
							key={member.threadActivity.id}
							event={member}
							hasEventAbove
							hasEventBelow={
								index === members.length - 1 ? hasEventBelow : true
							}
						/>
					))
				: null}
		</div>
	)
}
